module.exports = __webpack_public_path__ + "img/map.31923e7c.png";